import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

const DISMISS_KEY = "awg_install_dismissed";
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY)) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIos()) { setIos(true); setShow(true); }
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setShow(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setShow(false); else dismiss();
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:w-[360px] z-[60] rounded-2xl border border-zinc-700 bg-[#12141a]/95 backdrop-blur-xl shadow-2xl p-4 flex gap-3 items-start" data-testid="install-prompt">
      <img src="/icon-192.png" alt="" className="w-12 h-12 rounded-xl shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-white">Add All-Ways Graphic to your home screen</p>
        {ios ? (
          <p className="text-xs text-zinc-400 mt-1 leading-relaxed">Tap <Share size={12} className="inline -mt-0.5 text-[#22c3d6]" /> <span className="text-zinc-300">Share</span> then <span className="text-zinc-300">"Add to Home Screen"</span> to install it like an app.</p>
        ) : (
          <p className="text-xs text-zinc-400 mt-1">Opens full-screen, loads instantly, works like a native app.</p>
        )}
        {!ios && <button onClick={install} data-testid="install-prompt-install" className="mt-2 inline-flex items-center gap-1.5 text-xs font-semibold rounded-full px-3 py-1.5 bg-[#ff6a13] text-white hover:bg-[#ff8a3d]"><Download size={13} /> Install app</button>}
      </div>
      <button onClick={dismiss} data-testid="install-prompt-dismiss" className="text-zinc-500 hover:text-white p-1"><X size={16} /></button>
    </div>
  );
};
